import { initSubRoutes } from '../../../../utils/router';

const RoutesHistorique = initSubRoutes({
    route: '/historique',
    subroutes: {},
    nom: 'Historique',
});

export default RoutesHistorique;
